import { FC } from "react";

interface TrashFilledIconProps {
  color?: string;
  className?: string;
}

const TrashFilledIcon: FC<TrashFilledIconProps> = ({ className = "" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-[18px] h-[18px]"}
    >
      <path
        d="M15.0471 4.48683C13.9738 4.38016 12.9004 4.30016 11.8204 4.24016V4.2335L11.6738 3.36683C11.5738 2.7535 11.4271 1.8335 9.8671 1.8335H8.12043C6.5671 1.8335 6.42043 2.7135 6.31376 3.36016L6.17376 4.2135C5.55376 4.2535 4.93376 4.2935 4.31376 4.3535L2.95376 4.48683C2.67376 4.5135 2.47376 4.76016 2.50043 5.0335C2.5271 5.30683 2.7671 5.50683 3.0471 5.48016L4.4071 5.34683C7.90043 5.00016 11.4204 5.1335 14.9538 5.48683C14.9738 5.48683 14.9871 5.48683 15.0071 5.48683C15.2604 5.48683 15.4804 5.2935 15.5071 5.0335C15.5271 4.76016 15.3271 4.5135 15.0471 4.48683Z"
        fill="currentColor"
      />
      <path
        d="M13.8202 6.4265C13.6602 6.25984 13.4402 6.1665 13.2135 6.1665H4.78683C4.56016 6.1665 4.33349 6.25984 4.18016 6.4265C4.02683 6.59317 3.94016 6.81984 3.95349 7.05317L4.36683 13.8932C4.44016 14.9065 4.53349 16.1732 6.86016 16.1732H11.1402C13.4668 16.1732 13.5602 14.9132 13.6335 13.8932L14.0468 7.05984C14.0602 6.81984 13.9735 6.59317 13.8202 6.4265ZM10.1068 12.8332H7.88683C7.61349 12.8332 7.38683 12.6065 7.38683 12.3332C7.38683 12.0598 7.61349 11.8332 7.88683 11.8332H10.1068C10.3802 11.8332 10.6068 12.0598 10.6068 12.3332C10.6068 12.6065 10.3802 12.8332 10.1068 12.8332ZM10.6668 10.1665H7.33349C7.06016 10.1665 6.83349 9.93984 6.83349 9.6665C6.83349 9.39317 7.06016 9.1665 7.33349 9.1665H10.6668C10.9402 9.1665 11.1668 9.39317 11.1668 9.6665C11.1668 9.93984 10.9402 10.1665 10.6668 10.1665Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TrashFilledIcon;
